import { Carousel } from '@s4l/ds'
import styles from './style.module.css'
import { BreakpointSizes, useBrowser } from '@s4l/utils/hooks/useBrowser'

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { activeBreakpoint } = useBrowser()

  const isWide = activeBreakpoint >= BreakpointSizes.M

  return (
    <>
      {isWide ? (
        <div className={styles.desktopLayout}>{children}</div>
      ) : (
        <Carousel preset="single-items">
          <Carousel.Content initialItemIndex={0}>{children}</Carousel.Content>
          <Carousel.Dots />
        </Carousel>
      )}
    </>
  )
}
